import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';
import { CHECKBOX, RADIO } from '../constants';
import { FormInputContainerComponent, ItemComponent } from '../InputWrappersComponent';

const optionsGroup = ({
    input,
    meta,
    options,
    typeBox,
    classNameInputContainer,
    label,
    isInlineLabel,
    handleChecked,
    getInputName,
    handleOnChange,
    getInputValue
}) => {
    const currentValue = getInputValue(input, typeBox);
    return (
        <FormInputContainerComponent
            className={classNameInputContainer ? classNameInputContainer : ''}>
            <div className="item-wrapper-box-input flex-container-h flex-center-alt">
                {label && <div className="label">{label}</div>}
                <ItemComponent className="item">
                    <div className="options-box-input flex-container-h flex-center-alt">
                        {options.map((option, index) => {
                            return (
                                <div
                                    className="option-box-input flex-container-h flex-center-alt"
                                    key={`${typeBox}-${index}`}>
                                    <input
                                        type={typeBox}
                                        name={getInputName(input, index, typeBox)}
                                        value={option.value}
                                        checked={handleChecked(currentValue, option.value, typeBox)}
                                        id={`${input.name}-${index}`}
                                        className="box-input box-input-g-xl"
                                        onChange={event =>
                                            input.onChange(
                                                handleOnChange(
                                                    event,
                                                    currentValue,
                                                    option.value,
                                                    typeBox
                                                )
                                            )
                                        }
                                    />
                                    <label
                                        htmlFor={`${input.name}-${index}`}
                                        className="box-input-label flex-container-h flex-center-alt">
                                        {option.label}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                </ItemComponent>
            </div>
            {meta.touched && meta.error && <p className="color-err small">{meta.error}</p>}
        </FormInputContainerComponent>
    );
};
/**
 *
 * sidenote : we don't pass type props to Field because there is a bug whe, passing radio type to field,
 * so we passed a typeBox props and in the rendered component we set the real type ! HACK
 */
class BoxInputFieldComponent extends Component {
    render() {
        const { options, name, typeBox, validate, label, isRequired } = this.props;
        return (
            <Field
                {...this.props}
                name={name}
                label={`${label ? label : ''}${label && isRequired ? '*' : ''}`}
                options={options}
                typeBox={typeBox}
                validate={validate}
                component={optionsGroup}
            />
        );
    }
}

// See proptypes in ./InputFieldComponent.js for global Field props
BoxInputFieldComponent.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    typeBox: PropTypes.oneOf([CHECKBOX, RADIO]).isRequired,
    isInlineLabel: PropTypes.bool,
    i18nFeatureForm: PropTypes.object.isRequired
};

export default BoxInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/boxInput/BoxInputFieldComponent.js